<template>
  <div v-if="pageLoading">
    <a-spin tip="Your document is being processed, do not leave this page!" :spinning="pageLoading" />
  </div>
  <a-row :gutter="8" v-else>
    <a-col :xs="{ span: 24 }">
      <a-form :form="form">
        <a-form-item label="UM Detail">
          <a-select showSearch placeholder="UM Detail" class="select-between" v-decorator="[
            'um_detail',
            { rules: [{ required: true }] },
          ]" @change="handleChangeumDtl" option-filter-prop="children" :filter-option="filterOption">
            <a-select-option v-for="item in list_um" :key="item.id_um_dtl">
              <div class="select-option">
                <div v-if="!getScreen">
                  <h4>{{ item.item_nm }}</h4>
                </div>
                <h4 v-else>{{ item.item_nm }}</h4>
                <small>{{
                  formatRupiah(item.saldo_um)
                    .replace("Rp", "")
                    .replace(",00", "")
                }}</small>
              </div>
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="Description">
          <a-input v-decorator="['deskripsi', { rules: [{ required: true }] }]"></a-input>
        </a-form-item>
        <a-form-item label="Usage Date">
          <a-date-picker placeholder="Select Date" :format="getDefaultDateFormat"
            v-decorator="['tanggal_pemakaian', { rules: [{ required: true }] }]" />
        </a-form-item>
        <a-form-item label="Credit">
          <a-input-number :min="0" class="m-width-full m-text-align-right"
            :formatter="value => ` ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
            :parser="value => value.replace(/\\s?|(,*)/g, '')"
            v-decorator="['kredit', { rules: [{ required: true }, { validator: checkPrice }] }]" />
        </a-form-item>
        <a-row :gutter="12">
          <a-col :xs="{ span: 12 }" :lg="{ span: 12 }">
            <a-form-item label="Is Commission?">
              <a-radio-group v-decorator="[
                'iscommision',
                { rules: [{ required: false }], initialValue: '0' },
              ]" :disabled="EnCommission" button-style="solid" @change="handleOptionCommission">
                <a-radio-button value="1"> Yes </a-radio-button>
                <a-radio-button value="0"> No </a-radio-button>
              </a-radio-group>
            </a-form-item>
          </a-col>
          <a-col :xs="{ span: 12 }" :lg="{ span: 12 }">
            <!-- <a-form-item label="With Note?" :hidden="Viwithout_note"> -->
            <a-form-item label="With Note?" :hidden="true">
              <a-radio-group v-decorator="[
                'without_note',
                { rules: [{ required: false }], initialValue: '1' },
              ]" button-style="solid">
                <a-radio-button value="0"> Yes </a-radio-button>
                <a-radio-button value="1"> No </a-radio-button>
              </a-radio-group>
            </a-form-item>
          </a-col>
        </a-row>
        <a-form-item label="Upload Transaction Document">
          <a-upload :showUploadList="true" :fileList="doctransfiles" :beforeUpload="beforedoctransUpload"
            :remove="handledoctransRemove" v-decorator="['doctrans', { valuePropName: 'doctransfiles' }]">
            <a-button>
              <a-icon type="upload" />&nbsp;Select File
            </a-button>
          </a-upload>
        </a-form-item>
      </a-form>
      <a-divider class="margin-bottom-small">Or</a-divider>
      <div>
        <h4>Upload Excel File</h4>
        <p>
          If You Don't Have a File Upload Template Please
          Click
          <a-button class="padding-remove" type="link" @click="handleDownload">Download Template</a-button>
        </p>
        <a-upload accept=".xls, .xlsx" :showUploadList="true" :fileList="push" :beforeUpload="beforeUpload"
          :remove="handleRemove" v-decorator="['upload', { valuePropName: 'push' }]">
          <a-button>
            <a-icon type="upload" />&nbsp;Select File
          </a-button>
        </a-upload>
        <a-divider v-if="getScreen"></a-divider>
      </div>
      <a-button v-if="getScreen" type="primary" block @click="handleNew" :loading="newLoading">Add</a-button>
    </a-col>
    <a-col :xs="{ span: 24 }" v-if="getScreen">
      <a-collapse class="margin-top">
        <a-collapse-panel key="1">
          <h4 slot="header" class="margin-remove">View Details</h4>
          <a-list itemLayout="vertical" :dataSource="dataList" :pagination="pagination">
            <Empty v-if="dataList ? dataList.length <= 0 : dataList" />
            <a-list-item slot="renderItem" slot-scope="item">
              <a-list-item-meta>
                <a-row slot="title" type="flex" justify="space-between">
                  <a href="#">{{ item.deskripsi }}</a>
                </a-row>
                <p slot="description">
                <ul class="m-list-wrapper">
                  <li class="margin-remove">
                    {{ moment(item.tanggal_pemakaian).format(getDefaultDateFormat) }}
                  </li>
                  <li v-if="item.debit !== ''">
                    <h4 class="margin-remove m-text-sub">Debit</h4>
                    <h3 class="margin-remove">{{ formatCurrency(mata_uang, item.debit) }}</h3>
                  </li>
                  <li v-else>
                    <h4 class="margin-remove m-text-sub">Credit</h4>
                    <h3 class="margin-remove">{{ formatCurrency(mata_uang, item.kredit) }}</h3>
                  </li>
                </ul>
                </p>
              </a-list-item-meta>
              <a-button-group v-if="getScreen && item.kredit !== ''">
                <a-button type="primary" @click="handleEdit(item)">
                  <a-icon type="edit" />&nbsp;Edit
                </a-button>
                <a-button type="danger" @click="handleRemoveDetail(item)">
                  <a-icon type="close" />&nbsp;Remove
                </a-button>
              </a-button-group>
            </a-list-item>
          </a-list>
        </a-collapse-panel>
      </a-collapse>
      <div class="m-price-total" v-if="pageLoading === false">
        <div class="m-display-flex space-between align-middle">
          <h4>Debit</h4>
          <h3>{{ formatCurrency(mata_uang, debit) }}</h3>
        </div>
        <div class="m-display-flex space-between align-middle">
          <h4>Credit</h4>
          <h3>{{ formatCurrency(mata_uang, initialList.kredit) }}</h3>
        </div>
        <a-divider class="margin-small"></a-divider>
        <div class="m-display-flex space-between align-middle">
          <h4>Remaining Balance</h4>
          <h3>{{ formatCurrency(mata_uang, initialList.saldo) }}</h3>
        </div>
      </div>
      <a-checkbox v-model="checkCompleted"
        :disabled="dataList.length <= 1 || (getScreen && mode === 'Edit' && type === 'revised')"
        @change="handleCheckData">Is Data Completed?</a-checkbox>
    </a-col>

    <a-modal title="Confirmation" :visible="confirm" @ok="handleOk(type)" :confirmLoading="confirmLoading"
      @cancel="handleCancel" okText="OK" cancelText="Cancel">
      <p>Data that has been added will be overwritten with your new file? Are you sure?</p>
    </a-modal>
    <Modal :data="modal.data" :modalEdit="modal.modalEdit" :confirmLoading="modal.confirmLoading" />
  </a-row>
</template>

<script>
import axios from "axios";
import moment from "moment";
import { mapGetters } from "vuex";
import CurrencyFormat from "@/mixins/CurrencyFormat";
import Modal from "../Modal.vue";
import _ from "lodash";

export default {
  name: "pemakaian",
  components: {
    Modal,
  },
  mixins: [CurrencyFormat],
  props: {
    data: {},
    informasi: {},
    mode: {},
    url: "",
    id_lk: "",
    dataList: {},
    debit: 0,
    kredit: 0,
    mata_uang: "",
    type: "",
    limitasi: 0,
  },
  data() {
    return {
      list_um: [],

      // nanti dicek
      push: [],
      confirm: false,
      confirmLoading: false,
      newLoading: false,
      pageLoading: true,
      pagination: {
        onChange: (page) => { },
        pageSize: 5,
        size: "small",
      },
      initialEdit: {},
      modal: {
        modalEdit: false,
        confirmLoading: false,
        confirm: false,
        data: {
          tanggal_pemakaian: moment().format(),
          deskripsi: "",
          kredit: "",
          id: "",
          type: "",
          debit: 0,
          limitasi: 0,
          mata_uang: "",
        },
      },
      checkCompleted: false,
      EnCommission: true,
      Viwithout_note: true,
      doctransfiles: [],
    };
  },
  computed: {
    ...mapGetters([
      "getAuth",
      "getScreen",
      "getDefaultDateFormat",
      "getStandartFormatDate",
    ]),
    initialList() {
      if (this.dataList.length > 0) {
        let kredit = 0;
        let saldo = 0;
        let data = this.dataList.slice(1);
        if (this.dataList.length > 1 || this.dataList !== undefined) {
          data.forEach((item) => {
            kredit = Number(kredit) + Number(item.kredit);
          });
        }
        saldo = this.debit - kredit;

        return { kredit: kredit, saldo: saldo };
      } else {
        return { kredit: 0, saldo: 0 };
      }
    },
    watchDataList() {
      // if (this.dataList.length < 2) {
      //   console.log("redirect to create");
      // }
    },
  },
  beforeCreate() {
    this.form = this.$form.createForm(this);
    this.formEdit = this.$form.createForm(this);
  },
  methods: {
    moment,
    fetchUmList() {
      this.$store
        .dispatch("getLapDetilUM", {
          auth: this.getAuth,
          id: this.informasi.id_um,
        })
        .then((res) => {
          this.list_um = res.list_nama_item;
          this.pageLoading = false;
        });
    },
    checkPrice(rule, value, callback) {
      if (value > -1) {
        callback();
        return;
      }
      callback("Price must greater than  -1 !");
    },
    handleOk(e) {
      Event.$emit("handleLoading", true);
      this.ModalText = "The modal will be closed after two seconds";
      this.confirmLoading = true;

      let addData = new FormData();

      addData.append("tlc", this.getAuth.username);
      addData.append("id_lk", this.id_lk);
      addData.append("no_um", this.informasi.no_um);
      addData.append(
        "tanggal_pelaporan",
        this.informasi.tanggal_pelaporan.format(this.getDefaultDateFormat)
      );
      this.push.forEach((file) => {
        addData.append("file_upload", file);
      });
      addData.append("isparsial", this.informasi.isparsial);

      this.postUpload(addData);
    },
    handleCancel(e) {
      this.confirm = false;
      this.modal.modalEdit = false;
      Event.$emit("handleLoading", false);
    },
    handleNew() {
      Event.$emit("handleLoading", true);
      let addData = new FormData();
      addData.append("tlc", this.getAuth.username);
      addData.append("id_lk", this.id_lk);
      addData.append("no_um", this.informasi.no_um);
      addData.append(
        "tanggal_pelaporan",
        this.informasi.tanggal_pelaporan.format(this.getStandartFormatDate)
      );
      addData.append("isparsial", this.informasi.isparsial);
      addData.append("without_note", "1");
      addData.append("id", this.id_lk);

      if (this.push.length > 0 && this.dataList.length > 1) {
        this.confirm = true;
      } else if (this.push.length > 0) {
        this.push.forEach((file) => {
          addData.append("file_upload", file);
        });

        this.newLoading = true;
        this.pageLoading = true;

        addData.append("iscommision", "0");
        this.postUpload(addData);
      } else {
        this.form.validateFields((err, values) => {
          if (err) {
            this.newLoading = false;
            this.pageLoading = false;
            Event.$emit("handleLoading", false);
            this.displayMessage("form-warning");
            return;
          }

          if(moment(values.tanggal_pemakaian).format('YYYY-MM-DD')>moment().format('YYYY-MM-DD')){
            Event.$emit("handleLoading", false);
            this.displayMessageValue("error-other", "Usage date can't exceed today!");
            return;
          }

          addData.append("tanggal_pemakaian", this.moment(
            values.tanggal_pemakaian,
            this.getDefaultDateFormat
          ).format(this.getStandartFormatDate));
          addData.append("um_dtl", values.um_detail);
          addData.append("deskripsi", values.deskripsi);
          addData.append("kredit", values.kredit);
          addData.append("iscommision", values.iscommision);

          if (this.doctransfiles && this.doctransfiles.length > 0) {
            this.doctransfiles.forEach((file) => {
              addData.append("file_upload", file);
            });
          }

          let url =
            this.type == "revised"
              ? "lap_um_pd/revisi_detil_pemakaian"
              : "lap_um_pd/detil_pemakaian";

          this.$store
            .dispatch("addLapDetilUm", {
              auth: this.getAuth,
              data: addData,
              url: url,
            })
            .then((res) => {
              Event.$emit("fetchDetilUm", true);
              Event.$emit("fetchPemakaian");
              this.fetchUmList();
              this.form.resetFields();
              this.doctransfiles = [];
              this.EnCommission = false;
              this.Viwithout_note = true;
              Event.$emit("handleLoading", false);
              this.displayMessage("success-add");
            })
            .catch((err) => {
              Event.$emit("handleLoading", false);
              //this.displayMessage("over-kredit")
              let responses = Object.assign({}, err.response.data);
              //console.log(responses);
              this.displayMessageValue("error-other", responses.message);
            });
        });
      }
    },
    filterOption(input, option) {
      //console.log(option)
      return (
        option.componentOptions.children[0].children[0].elm.innerText
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    handleDownload() {
      axios({
        method: "get",
        url: this.$serviceUrl + "/main/download_template",
        params: {
          id_lk: this.id,
          tlc: this.getAuth.username,
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      })
        .then((response) => {
          window.open(this.$serviceUrl + response.data.url, "_blank");
        })
        .catch((err) => {
          this.displayMessage("error-emptyDocTemplate");
        });
    },
    beforeUpload(file) {
      const FileSize = file.size / 1024 / 1024;
      let extension =
        file.name.substr(file.name.lastIndexOf(".")) == ".xls" ||
        file.name.substr(file.name.lastIndexOf(".")) == ".xlsx";
      if (extension) {
        if (FileSize > 2) {
          this.displayMessage("large-file-2mb");
        } else {
          this.push = [file];
          this.form.resetFields();
          return false;
        }
      } else {
        this.displayMessage("error-formatXls");
      }
    },
    postUpload(data) {
      let urlApi = "";
      if (this.type == "revised") {
        urlApi = "lap_um_pd/revisi_upload_detil_pemakaian";
      } else {
        urlApi = "lap_um_pd/upload_detil_pemakaian";
      }

      Event.$emit("loadParentPage", true);
      axios({
        method: "post",
        url: this.$serviceUrl + urlApi,
        processData: false,
        data: data,
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "Content-Type": "multipart/form-data",
          "X-API-KEY": this.getAuth.apikey,
        },
      })
        .then((response) => {
          Event.$emit("loadParentPage", false);
          if (this.mode === "Create") {
            this.displayMessage("success-add");
            Event.$emit("fetchDetilUm", true);
            Event.$emit("fetchPemakaian", true);
            this.confirmLoading = false;
            this.newLoading = false;
            this.pageLoading = false;
            this.confirm = false;
          } else {
            this.displayMessage("success-edit");
            Event.$emit("fetchDetilUm", true);
            Event.$emit("fetchPemakaian", true);
            this.confirmLoading = false;
            this.newLoading = false;
            this.pageLoading = false;
            this.confirm = false;
          }
          Event.$emit("handleLoading", false);
        })
        .catch((err) => {
          //console.log(err)
          Event.$emit("handleLoading", false);
          Event.$emit("loadParentPage", false);
          let response = Object.assign({}, err.response);
          if (response.data) {
            if (
              err.response.data.message ===
              "Total nilai yang Diinputkan melebihi limit nilai Laporan UM"
            ) {
              this.displayMessageValue(
                "limit-lap",
                this.formatCurrency(this.mata_uang, this.debit + this.limitasi)
              );
            } else if (
              err.response.data.message === "Upload failed. File is empty"
            ) {
              this.displayMessage("wrong-format");
            }
          } else {
            if (response.status == false && response.message) {
              this.displayMessageValue("error", response.message);
            } else {
              this.displayMessageValue("error", response);
            }
          }
          this.confirmLoading = false;
          this.newLoading = false;
          this.pageLoading = false;
          this.confirm = false;
          Event.$emit("disableInformasi", true);
        });
    },
    done() {
      this.pageLoading = false;
      this.push = [];
    },
    handleRemove() {
      this.push = [];
    },
    handleCheckData(e) {
      Event.$emit("draftStatus", e.target.checked);
    },
    handleOptionCommission(val) {
      //console.log(val)
      if (val.target.value == "1") {
        this.Viwithout_note = false;
      } else {
        this.Viwithout_note = true;
      }
      this.$nextTick(function () {
        this.form.setFieldsValue({
          without_note: "0",
        });
      });
    },
    handleChangeumDtl(val) {
      //console.log(val)
      let selectedumDtl = _.filter(this.list_um, { id_um_dtl: val });
      if (selectedumDtl[0] && selectedumDtl[0].is_komisi) {
        this.EnCommission = true;
        this.Viwithout_note = false;
        this.$nextTick(function () {
          this.form.setFieldsValue({
            iscommision: "1",
            without_note: "1",
          });
        });
      } else {
        this.EnCommission = false;
        this.Viwithout_note = true;
        this.$nextTick(function () {
          this.form.setFieldsValue({
            iscommision: "0",
            without_note: "1",
          });
        });
      }
    },
    beforedoctransUpload(file) {
      const FileSize = file.size / 1024 / 1024;
      if (FileSize > 5) {
        this.displayMessage("large-file-5mb");
      } else {
        this.doctransfiles = [file];
        return false;
      }
    },
    handledoctransRemove() {
      this.doctransfiles = [];
    },
  },
  mounted() {
    this.fetchUmList();
    Event.$on("messagelimit", this.messagelimit);
    Event.$on("modalCancel", this.handleCancel);
    Event.$on("fetchUmList", this.fetchUmList);
  },
  beforeDestroy() {
    Event.$off("messagelimit", this.messagelimit);
    Event.$off("modalCancel", this.handleCancel);
    Event.$off("fetchUmList", this.fetchUmList);
  },
};
</script>

<style lang="less">
.select {
  &-option {
    display: flex;
    flex-direction: row;
    justify-content: space-between;

    >div {
      display: flex;
      gap: @padding / 2;
    }
  }

  &-between {
    .ant-select-selection {
      width: 100%;
      display: flex;

      &__rendered {
        flex: 1;
        padding-right: @padding;
        display: flex;
      }

      &-selected-value {
        flex: 1;
      }
    }
  }
}
</style>